export const TwitterIconOne = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="28" viewBox="0 0 27 28" fill="none">
            {/* <path d="M26.9999 14.417C26.9999 6.96113 20.9558 0.916992 13.5 0.916992C6.04414 0.916992 0 6.96113 0 14.417C0 21.8728 6.04414 27.9169 13.5 27.9169C20.9558 27.9169 26.9999 21.8728 26.9999 14.417Z" fill="white" /> */}
            <path d="M15.1415 13.4223L19.6085 7.91699H18.5495L14.6705 12.6972L11.573 7.91699H8L12.6845 15.1445L8 20.917H9.059L13.1555 15.8697L16.427 20.917H20L15.1415 13.4207V13.4223ZM9.4415 8.7614H11.0675L18.5525 20.1108H16.9265L9.4415 8.7614Z" fill="#1F1F1F" />
        </svg>
    )
}